import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import NaturmarketImage from '../../assets/images/Naturmarket.png';
import Button from '../common/Button';
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import useAuth from "../../hooks/useAuth";

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  //const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();
  const { user, isAdmin, loading } = useAuth();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLinkClick = (path) => (e) => {
    if (location.pathname === path) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleLogout = async () => {
    const token = localStorage.getItem("token");

    try {
        await fetch(`${process.env.REACT_APP_API_URL}/api/auth/logout`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
    } catch (e) {
        console.error("Logout request failed");
    }

    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("userId");
    window.location.href = "/SignOut";
};

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    
    /*
    // Check login status and admin role
    const secretKey = "din-hemliga-nyckel";
    const encryptedAccess = Cookies.get("access");
    if (encryptedAccess) {
      try {
        const bytes = CryptoJS.AES.decrypt(encryptedAccess, secretKey);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        if (decrypted) {
          setIsLoggedIn(true);
          if (decrypted === "ADMIN") {
            setIsAdmin(true);
          }
        }
      } catch (e) {
        console.error("Failed to decrypt cookie", e);
      }
    }*/

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 flex border-b border-gray-200 py-2 px-4 sm:px-10 bg-offwhite font-body min-h-[56px] tracking-wide z-50 transition-shadow duration-300 ${isScrolled ? 'shadow-lg' : ''}`}>
      <div className="flex flex-wrap items-center gap-3 w-full">
        {/* Logo */}
        <Link to="/" onClick={handleLinkClick('/')} className="flex items-center">
          <img src={NaturmarketImage} alt="Naturborgarmärket" className="w-10 h-10 rounded-full transform scale-[1.25]" />
        </Link>

        {/* Desktop Navigation */}
        <div className={`lg:!flex lg:flex-auto lg:ml-8 max-lg:fixed max-lg:bg-offwhite max-lg:w-full max-lg:top-[56px] max-lg:left-0 max-lg:py-4 z-50 max-lg:transition-all max-lg:duration-300 max-lg:ease-in-out max-lg:origin-top max-lg:border-b max-lg:border-sage ${isMobileMenuOpen ? 'max-lg:scale-y-100 max-lg:opacity-100' : 'max-lg:scale-y-0 max-lg:opacity-0 max-lg:pointer-events-none'}`}>
          
          <div className="lg:!flex lg:flex-auto">
            <ul className="lg:flex lg:gap-x-2 max-lg:space-y-2 max-lg:flex max-lg:flex-col max-lg:items-center">

              {/* Navigation Links */}
              <li className="max-lg:border-b max-lg:border-sage max-lg:py-2">
                <Link to="/" onClick={handleLinkClick('/')} className={`text-charcoal block font-semibold text-[16px] px-3 py-2 relative after:content-[''] after:absolute after:bottom-1 after:left-3 after:h-[2px] after:bg-forest after:transition-all after:duration-300 ${location.pathname === '/' ? 'after:w-[calc(100%-1.5rem)]' : 'after:w-0 hover:after:w-[calc(100%-1.5rem)]'}`}>
                  Hem
                </Link>
              </li>
              <li className="max-lg:border-b max-lg:border-sage max-lg:py-2">
                <Link to="/quiz" onClick={handleLinkClick('/quiz')} className={`text-charcoal block font-semibold text-[16px] px-3 py-2 relative after:content-[''] after:absolute after:bottom-1 after:left-3 after:h-[2px] after:bg-forest after:transition-all after:duration-300 ${location.pathname === '/Quiz' ? 'after:w-[calc(100%-1.5rem)]' : 'after:w-0 hover:after:w-[calc(100%-1.5rem)]'}`}>
                  Quiz
                </Link>
              </li>
              <li className="max-lg:border-b max-lg:border-sage max-lg:py-2">
                <Link to="/omraden" onClick={handleLinkClick('/omraden')} className={`text-charcoal block font-semibold text-[16px] px-3 py-2 relative after:content-[''] after:absolute after:bottom-1 after:left-3 after:h-[2px] after:bg-forest after:transition-all after:duration-300 ${location.pathname === '/Map' ? 'after:w-[calc(100%-1.5rem)]' : 'after:w-0 hover:after:w-[calc(100%-1.5rem)]'}`}>
                  Område
                </Link>
              </li>
              <li className="max-lg:border-b max-lg:border-sage max-lg:py-2">
                <Link to="/arter" onClick={handleLinkClick('/arter')} className={`text-charcoal block font-semibold text-[16px] px-3 py-2 relative after:content-[''] after:absolute after:bottom-1 after:left-3 after:h-[2px] after:bg-forest after:transition-all after:duration-300 ${location.pathname === '/Species-info' ? 'after:w-[calc(100%-1.5rem)]' : 'after:w-0 hover:after:w-[calc(100%-1.5rem)]'}`}>
                  Arter
                </Link>
              </li>
              <li className="max-lg:border-b max-lg:border-sage max-lg:py-2">
                <Link to="/allemansratten" onClick={handleLinkClick('/allemansratten')} className={`text-charcoal block font-semibold text-[16px] px-3 py-2 relative after:content-[''] after:absolute after:bottom-1 after:left-3 after:h-[2px] after:bg-forest after:transition-all after:duration-300 ${location.pathname === '/allemansratten' ? 'after:w-[calc(100%-1.5rem)]' : 'after:w-0 hover:after:w-[calc(100%-1.5rem)]'}`}>
                  Allemansrätten
                </Link>
              </li>
              <li className="max-lg:border-b max-lg:border-sage max-lg:py-2">
                <Link to="/om" onClick={handleLinkClick('/om')} className={`text-charcoal block font-semibold text-[16px] px-3 py-2 relative after:content-[''] after:absolute after:bottom-1 after:left-3 after:h-[2px] after:bg-forest after:transition-all after:duration-300 ${location.pathname === '/About' ? 'after:w-[calc(100%-1.5rem)]' : 'after:w-0 hover:after:w-[calc(100%-1.5rem)]'}`}>
                  Om
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-l border-gray-200 h-5 max-lg:hidden"></div>

        {/* Auth Buttons */}
        <div className="flex items-center ml-auto space-x-3">
          {!user ? (
            <>
              <Button to="/SignIn" variant="secondary" className="max-lg:hidden h-9 px-4 text-sm border-gray-200">
                Logga in
              </Button>
              <Button to="/SignUp" variant="default" className="h-9 px-4 text-sm">
                Registrera
              </Button>
            </>
          ) : (
            <>
              {isAdmin && (
                <Button to="/admin" variant="default" className="h-9 px-4 text-sm">
                  Admin
                </Button>
              )}
              <Button onClick={handleLogout} variant="secondary" className="h-9 px-4 text-sm">
                Logga ut
              </Button>
            </>
          )}
        </div>

        {/* Mobile menu toggle */}
        <div className={`${isLoggedIn ? 'ml-auto' : ''} lg:hidden`}>
          <button onClick={toggleMobileMenu} className="focus:outline-none p-1 bg-offwhite">
            <svg className="w-6 h-6" fill="#2B2B2B" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
}